import { normalizeNamespace } from './client';

/**
 * Sites API service
 */
export class SitesApi {
  constructor(apiClient) {
    this.client = apiClient;
  }

  /**
   * Get paginated list of sites
   */
  getSites(namespace, params = {}) {
    const ns = normalizeNamespace(namespace);
    const {
      offset, limit, view, sortby, source, filter, listId, tagId,
    } = params;
    const queryParams = {
      ...(offset !== undefined && { offset }),
      ...(limit !== undefined && { limit }),
      ...(view && { view }),
      ...(sortby && { sortby }),
      ...(source && { source }),
      ...(filter && { filter }),
      ...(listId && { list_id: listId }),
      ...(tagId && { tag_id: tagId }),
    };
    return this.client.get(`/${ns}/sites`, queryParams);
  }

  /**
   * Get single site by ID with namespace
   */
  getSiteById(namespace, siteId) {
    const ns = normalizeNamespace(namespace);
    return this.client.get(`/${ns}/sites/${siteId}`);
  }

  /**
   * Create new site
   */
  createSite(site) {
    return this.client.post('/private/sites', site);
  }

  /**
   * Bookmark a public site.
   */
  bookmarkSite(siteId) {
    return this.client.post('/private/sites', { id: siteId });
  }

  /**
   * Update site
   */
  updateSite(namespace, siteId, patch) {
    const ns = normalizeNamespace(namespace);
    return this.client.patch(`/${ns}/sites/${siteId}`, patch);
  }

  /**
   * Delete site
   */
  deleteSite(namespace, siteId) {
    const ns = normalizeNamespace(namespace);
    return this.client.delete(`/${ns}/sites/${siteId}`);
  }

  /**
   * Share site (create pending copy for approval)
   */
  shareSite(siteId) {
    return this.client.post(`/pending/sites/${siteId}`);
  }

  /**
   * Merge sites.
   */
  mergeSites(namespace, targetSiteId, sourceSiteIds) {
    const ns = normalizeNamespace(namespace);
    return this.client.patch(`/${ns}/sites/${targetSiteId}/merge`, { siteIds: sourceSiteIds });
  }
}

export default SitesApi;
